module.exports = __webpack_public_path__ + "static/media/Lost_Found.8c66214d.mp3";